import { RectangleMarker } from '../rectangle/rectangleMarker'
import { SelectionMarkerRenderer } from './selectionMarkerRenderer'
import { SelectionMarkerController } from './selectionMarkerController'
import { SelectionMarkerStateManager } from './selectionMarkerStateManager'

class SelectionMarker extends RectangleMarker {
  constructor() {
    super()
    this.controller = new SelectionMarkerController(this)
    this.renderer = new SelectionMarkerRenderer(this)
    this.state = new SelectionMarkerStateManager(this)
  }

  public static typeName = 'SelectionMarker'

  setupStroke() {
    const p = this.p
    p.strokeWeight(this.state.strokeWeight)
    p.stroke(211, 211, 211, 255)
    p.fill(211, 211, 211, 100)
  }
}

export { SelectionMarker }
